import React from 'react';
import Badge, { BadgeType } from '@zvuk-b2b/react-uikit/ui/Badge';
import { MediaFileTypes } from '@shared/config/media';

import { ADS_PAGE_PATH_ALIAS } from 'application/pages/AdsPage';
import { useLocation } from 'application/providers/RouterProvider';
import { PROMO_LABEL } from '../../MediaListItem/texts';

import styles from './index.module.scss';
import { MediaListItemIconsPromoProps } from './types';

const MediaListItemIconsPromo: React.FC<MediaListItemIconsPromoProps> = ({ type }) => {
  const location = useLocation();

  const isPromo =
    type === MediaFileTypes.PROMO || type === MediaFileTypes.VIDEO_PROMO || type === MediaFileTypes.IMAGE_PROMO;
  const isPromoBadgePathHide = location.pathname.includes(ADS_PAGE_PATH_ALIAS);
  const isPromoVisible = isPromo && !isPromoBadgePathHide;

  if (isPromoVisible) {
    return (
      <Badge
        label={PROMO_LABEL}
        type={BadgeType.Neutral2}
        className={styles.Promo}
      />
    );
  }

  return null;
};

export default MediaListItemIconsPromo;
